import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useTranslate } from 'hooks/useTranslate';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import Breadcrumb, {
  BreadcrumbItem,
} from 'modules/_shared/components/Breadcrumb';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import { TradingOfferType } from 'types/TradingOffer';
import { useAddTradingOfferPage } from './context/AddTradingOfferPageContext';
import AddTradingOfferPageBody from './components/AddTradingOfferPageBody';
import { addTradingOfferLabels } from './constants/addTradingOfferLabels';

const AddTradingOfferPage: FC = () => {
  const { t } = useTranslate();
  const location = useLocation();
  const partnerQuery = new URLSearchParams(location.search).get('partnerId');
  const pq = partnerQuery ? `?partnerId=${partnerQuery}` : '';

  const { data } = useAddTradingOfferPage();

  const { tradingOfferType } = data;

  const labels = useMemo(
    () => addTradingOfferLabels[tradingOfferType as TradingOfferType],
    [tradingOfferType]
  );

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('Dashboard'), to: '/' },
      { label: data.societyName, to: `/sociedad/${data.societyId}` },
      {
        label: t('EquityMarket'),
        to: `/mercado-de-acciones/${data.societyId}${pq}`,
      },
      {
        label: t(labels.BREADCRUMB),
        isActive: true,
      },
    ],
    [t, data.societyName, data.societyId, tradingOfferType, pq]
  );

  const pageActions = [<GoBackButton key="go-back" icon="ni-arrow-left" />];

  return (
    <Page>
      <div className="nk-block-head-content mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <PageListHeader
        subTitle={t(labels.TITLE)}
        description={t(labels.DESCRIPTION)}
        actions={pageActions}
      />

      <AddTradingOfferPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default AddTradingOfferPage;
